import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import Spinner from '../../components/ui/spinner';
import { get } from '../../core/client';
import { getLocalStorageItem } from '../../core/utility';
import { useAppSelector } from '../../store';
import { getAllEmployees, getBulletin, getDepartments, getEvents, getSpecialNameList, getTutorial, getUserTeams } from '../../store/features/moments/momentsSlice';
import { getUserInfo, setMyUserInfo, getUserClaims } from '../../store/features/user/usersSlice';
import Tuttorial from '../tuttorial';
import CreateAction from './create-actions';
import CreateMoment from './create-momets';
import AsideMenu from './home-aside/asideMenu';
import SectionCalendar from './home-aside/sectionCalendar';
import SectionEvents from './home-aside/sectionEvents';
import MyTeams from './my-teams';
import SpecialMoments from './special-moments/specialMoments';

const Moments = () => {
    const dispatch = useDispatch();
    const { filter, page, tuttorialIndex, aside } = useAppSelector(state => state.moments);


    const [isFirstLogin, setIsFirstLogin] = useState<boolean>(false);
    const { userClaims } = useAppSelector(state => state.users);
    
    const selectedLanguageLs = getLocalStorageItem('SelectedLanguage') && getLocalStorageItem('SelectedLanguage')?.languageName;

    useEffect(() => {
        get<any>(`/users/isfirstlogin`).then(response => setIsFirstLogin(response.result));
        dispatch(getUserInfo());
        dispatch(setMyUserInfo());
        dispatch(getUserClaims());
        dispatch(getSpecialNameList());
        
    }, []);

    useEffect(() => {
        dispatch(getDepartments());
        dispatch(getAllEmployees());
        dispatch(getTutorial());
        dispatch(getBulletin());
        dispatch(getUserTeams())
    }, [selectedLanguageLs]);

    useEffect(() => {
        if (userClaims.items.length > 0 && !userClaims?.items?.some(x => x.value === 'UserSpecialDateMain_List')) {
            window.location.href = '/autWarning';
        }
    }, [userClaims]);

    useEffect(() => {
        dispatch(getEvents(filter));
    }, [filter]);

    if (aside?.departments?.length === 0) {
        return <Spinner />;
    }
    return (
        <section className="section-01">
            <div className="c-wrapper">
                <AsideMenu />

                {page.name === 'momentsHome' && (
                    <>
                        {(tuttorialIndex === 0 || tuttorialIndex === 1) && isFirstLogin && <Tuttorial />}
                        <SectionEvents />
                        <SectionCalendar />
                    </>
                )}
                {page.name === 'createMoment' && <CreateMoment />}
                {page.name === 'createAction' && <CreateAction />}
                {page.name === 'myTeams' && <MyTeams />}
                {page.name === 'bulletin' && <MyTeams />}
                {page.name === 'specialMoments' && <SpecialMoments />}
            </div>
        </section>
    );
};

export default Moments;
